import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface CardOneProps {
  children: ReactNode
  className?: string
}

const CardOne = ({ children, className }: CardOneProps) => {
  return <div className={twMerge('bg-body px-3 py-5 rounded-2xl w-full', className)}>{children}</div>
}

export default CardOne
